import axios from "axios";
import { sessionServices } from "../../Utils/SessionServices";


const generateHeaders = (headers) => {
    const token = sessionStorage.getItem("token")
    if (!token) {
        return headers
    }

    const configObj = {
        Authorization: `Bearer ${token}`,
        ...headers,
    }
    return { ...configObj }
}

export const networkRequest = axios.create({})

networkRequest.interceptors.request.use((config) => {
    config.headers = generateHeaders(config.headers)
    return config
});

networkRequest.interceptors.response.use(
    (value) => {
        return Promise.resolve(value)
    },
    (error) => {
        if (error.response.status === 401) {
            sessionServices?.clearSessionStorage()
                .then(() => {
                    window.location.href = `/login`
                }).catch((err) => {
                    console.log(err)
                })
        }
        return Promise.reject(error)
    }
)